import productReviewHtml from './productreview.component.html';

class ProductReviewController {
    constructor($scope, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.ModalService = ModalService;
    }

    review() {
        const modalRef = this.ModalService.add(
            `Dodaj opinię produktu ${this.product.name}`,
            `<product-review-add product-id="${this.product.id}" product-name="'${this.product.name}'" user-is-logged-in="${this.userIsLoggedIn}"></product-review-add>`,
            null,
            false,
            'add-product-review-modal'
        );

        modalRef.open();
    }
}

let productReviewComponent = {
    bindings: {
        product: '<',
        userIsLoggedIn: '<'
    },
    template: productReviewHtml,
    controller: ProductReviewController
};

export default productReviewComponent;
